import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=54e93ffa&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=54e93ffa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e93ffa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54e93ffa')) {
      api.createRecord('54e93ffa', component.options)
    } else {
      api.reload('54e93ffa', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=54e93ffa&scoped=true&", function () {
      api.rerender('54e93ffa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2UCdBER602c4z/JS/comp/SearchFilterTokens.vue"
export default component.exports